module.exports = __webpack_public_path__ + "a872e780b80ee740995ab9644d0105b1.png";